var map = {
	"./bonus_50000.png": 215,
	"./btn_gradient.png": 216,
	"./game_grid.png": 217,
	"./game_grid_blue.png": 218,
	"./game_grid_old.png": 219,
	"./hint_background.png": 220,
	"./letters/a.jpg": 75,
	"./letters/and.jpg": 76,
	"./letters/apos.jpg": 77,
	"./letters/b.jpg": 78,
	"./letters/c.jpg": 79,
	"./letters/d.jpg": 80,
	"./letters/dash.jpg": 81,
	"./letters/e.jpg": 82,
	"./letters/exclaim.jpg": 83,
	"./letters/f.jpg": 84,
	"./letters/g.jpg": 85,
	"./letters/h.jpg": 86,
	"./letters/i.jpg": 87,
	"./letters/j.jpg": 88,
	"./letters/k.jpg": 89,
	"./letters/l.jpg": 90,
	"./letters/m.jpg": 91,
	"./letters/n.jpg": 92,
	"./letters/o.jpg": 93,
	"./letters/p.jpg": 94,
	"./letters/period.jpg": 95,
	"./letters/q.jpg": 96,
	"./letters/quest.jpg": 97,
	"./letters/r.jpg": 98,
	"./letters/s.jpg": 99,
	"./letters/selected.jpg": 100,
	"./letters/space.jpg": 101,
	"./letters/t.jpg": 102,
	"./letters/u.jpg": 103,
	"./letters/v.jpg": 104,
	"./letters/w.jpg": 105,
	"./letters/x.jpg": 106,
	"./letters/y.jpg": 107,
	"./letters/z.jpg": 108,
	"./lettersblue/a.jpg": 221,
	"./lettersblue/and.jpg": 222,
	"./lettersblue/apos.jpg": 223,
	"./lettersblue/b.jpg": 224,
	"./lettersblue/c.jpg": 225,
	"./lettersblue/d.jpg": 226,
	"./lettersblue/dash.jpg": 227,
	"./lettersblue/e.jpg": 228,
	"./lettersblue/exclaim.jpg": 229,
	"./lettersblue/f.jpg": 230,
	"./lettersblue/g.jpg": 231,
	"./lettersblue/h.jpg": 232,
	"./lettersblue/i.jpg": 233,
	"./lettersblue/j.jpg": 234,
	"./lettersblue/k.jpg": 235,
	"./lettersblue/l.jpg": 236,
	"./lettersblue/m.jpg": 237,
	"./lettersblue/n.jpg": 238,
	"./lettersblue/o.jpg": 239,
	"./lettersblue/p.jpg": 240,
	"./lettersblue/period.jpg": 241,
	"./lettersblue/q.jpg": 242,
	"./lettersblue/r.jpg": 243,
	"./lettersblue/s.jpg": 244,
	"./lettersblue/selected.jpg": 245,
	"./lettersblue/space.jpg": 246,
	"./lettersblue/t.jpg": 247,
	"./lettersblue/u.jpg": 248,
	"./lettersblue/v.jpg": 249,
	"./lettersblue/w.jpg": 250,
	"./lettersblue/x.jpg": 251,
	"./lettersblue/y.jpg": 252,
	"./lettersblue/z.jpg": 253,
	"./lettersdarkblue/a.jpg": 254,
	"./lettersdarkblue/and.jpg": 255,
	"./lettersdarkblue/apos.jpg": 256,
	"./lettersdarkblue/b.jpg": 257,
	"./lettersdarkblue/c.jpg": 258,
	"./lettersdarkblue/d.jpg": 259,
	"./lettersdarkblue/dash.jpg": 260,
	"./lettersdarkblue/e.jpg": 261,
	"./lettersdarkblue/exclaim.jpg": 262,
	"./lettersdarkblue/f.jpg": 263,
	"./lettersdarkblue/g.jpg": 264,
	"./lettersdarkblue/h.jpg": 265,
	"./lettersdarkblue/i.jpg": 266,
	"./lettersdarkblue/j.jpg": 267,
	"./lettersdarkblue/k.jpg": 268,
	"./lettersdarkblue/l.jpg": 269,
	"./lettersdarkblue/m.jpg": 270,
	"./lettersdarkblue/n.jpg": 271,
	"./lettersdarkblue/o.jpg": 272,
	"./lettersdarkblue/p.jpg": 273,
	"./lettersdarkblue/period.jpg": 274,
	"./lettersdarkblue/q.jpg": 275,
	"./lettersdarkblue/r.jpg": 276,
	"./lettersdarkblue/s.jpg": 277,
	"./lettersdarkblue/selected.jpg": 278,
	"./lettersdarkblue/space.jpg": 279,
	"./lettersdarkblue/t.jpg": 280,
	"./lettersdarkblue/u.jpg": 281,
	"./lettersdarkblue/v.jpg": 282,
	"./lettersdarkblue/w.jpg": 283,
	"./lettersdarkblue/x.jpg": 284,
	"./lettersdarkblue/y.jpg": 285,
	"./lettersdarkblue/z.jpg": 286,
	"./mute_icon_off.png": 287,
	"./mute_icon_on.png": 288,
	"./orientation_message.png": 289,
	"./wheel/5000.png": 109,
	"./wheel/500green.png": 110,
	"./wheel/500pink.png": 111,
	"./wheel/500violet.png": 112,
	"./wheel/550blue.png": 113,
	"./wheel/600blue.png": 114,
	"./wheel/600red.png": 115,
	"./wheel/650pink.png": 116,
	"./wheel/650violet.png": 117,
	"./wheel/700blue.png": 118,
	"./wheel/700red.png": 119,
	"./wheel/700yellow.png": 120,
	"./wheel/800orange.png": 121,
	"./wheel/800red.png": 122,
	"./wheel/900orange.png": 123,
	"./wheel/900pink.png": 124,
	"./wheel/900yellow.png": 125,
	"./wheel/bankrupt.png": 126,
	"./wheel/special.png": 127,
	"./wheel/spin_now_arrow.png": 128,
	"./wheel/spin_now_arrow_mobile.png": 129,
	"./wheel/wedge-LITEGAME-TEMPLATE.png": 130,
	"./wheel/wheel-LITEGAME-TEMPLATE(old).png": 131,
	"./wheel/wheel-LITEGAME-TEMPLATE.png": 132,
	"./wheel/wheel.png": 133,
	"./wof_logo.png": 290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74;